import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME, subscribeRealtimeDataPutThrough } from './reducer';
import TablePutThroughHnx from './summary/TablePutThroughHnx';
import TablePutThroughUpcom from './summary/TablePutThroughUpcom';
import TablePutThroughHose from './summary/TablePutThroughHose';
import { Responsive } from '../../common/responsive';
import MessageHub from '../../../core/signalr/SignalrMessageHub';
import { ChanelConfig } from '../../../configs/GlobalConfig';

class PutThrough extends React.Component {
  componentDidMount() {
    MessageHub.subscribe(ChanelConfig.TickChanel, this.handleRealTimeData);
  }

  componentWillUnmount() {
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.handleRealTimeData);
  }

  handleRealTimeData = data => {
    const { subscribeRealtimeDataPutThrough } = this.props;
    subscribeRealtimeDataPutThrough(data);
  };

  render() {
    const { component } = this.props;

    return (
      <div className="d-flex flex-fill pl-20 pr-20 mt-10">
        <Responsive component={component} offsetWidth={40} margin={5}>
          {() => <TablePutThroughHose />}
          {() => <TablePutThroughHnx />}
          {() => <TablePutThroughUpcom />}
        </Responsive>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    component: state[REDUCER_NAME].component,
    listDataRealTimePutThrough: state[REDUCER_NAME].listDataRealTimePutThrough,
  };
};

const mapDispatchToProps = {
  subscribeRealtimeDataPutThrough,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PutThrough);
